import React from "react";
import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";

import AppListItem from "./AppListItem";

import "../styles/appNavList.scss";

export default function AppNavList({ list = [], header }) {
  return (
    <React.Fragment>
      {header && <ListSubheader inset>{header}</ListSubheader>}
      <List className="app-nav-list" style={{ padding: 0 }}>
        {list.map((item, ind) => {
          return (
            <AppListItem
              onClick={() => item.onClick && item.onClick(item)}
              key={String(ind)}
              {...item}
            />
          );
        })}
      </List>
    </React.Fragment>
  );
}
